import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Validator} from '@iotsens/commands';
import {BehaviorSubject, Observable} from 'rxjs';

@Component({
  selector: 'app-generic-command-input',
  templateUrl: './generic-command-input.component.html',
  styleUrls: ['./generic-command-input.component.scss']
})
export class GenericCommandInputComponent implements OnInit {

  @Input() validators: Validator[];
  @Input() value: any;
  @Output() valueChange: EventEmitter<any>;

  private isValidSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isValid$: Observable<boolean> = this.isValidSubject.asObservable();

  constructor() {
    this.valueChange = new EventEmitter<any>();
  }

  ngOnInit(): void {
    this.isValidSubject.next(true);
  }

  public emitFields(event: any): void {
    this.value = event;
    this.valueChange.emit(this.value);
  }

  validate(input: HTMLInputElement): void {
    this.isValidSubject.next(input.checkValidity());
  }
}
